import PropTypes from "prop-types";
import classNames from "classnames";
import RadioCircle from "../../../../UI/RadioCircle/RadioCircle";
import TablePriceCell from "../../../../Table/TablePriceCell/TablePriceCell";
import classes from "./OrderItemPrice.module.css";

const OrderItemPrice = (props) => {
  const {
    priceId,
    supplierId,
    comment,
    price,
    suggestedSellingPrice,
    checked,
    onChange,
    hasError,
  } = props;

  return (
    <>
      <li
        className={classNames(classes["order-item-price"], {
          [classes["order-item-price--checked"]]: checked,
          [classes["order-item-price--error"]]: hasError,
        })}
      >
        <input
          id={priceId}
          type="radio"
          value={JSON.stringify({
            price,
            suggestedSellingPrice,
            selectedSupplierId: supplierId,
          })}
          name="order-item-price"
          checked={checked}
          onChange={onChange}
          className="hidden"
        />
        <label htmlFor={priceId} className={classes["order-item-price__label"]}>
          <RadioCircle
            checked={checked}
            className={classes["order-item-price__label-circle"]}
          />
          <p className={classes["order-item-price__label-comment"]}>
            {comment}
          </p>
          <TablePriceCell
            price={price}
            className={classes["order-item-price__label-price"]}
          />
        </label>
      </li>
      {checked && (
        <p className={classes["order-item-price__selected-text"]}>
          تم تحديد هذا السعر
        </p>
      )}
    </>
  );
};

export default OrderItemPrice;

OrderItemPrice.propTypes = {
  priceId: PropTypes.number,
  supplierId: PropTypes.number,
  comment: PropTypes.string,
  price: PropTypes.number,
  suggestedSellingPrice: PropTypes.number,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  hasError: PropTypes.bool,
};
